__turbopack_context__.v({
  "animate-shine": "animations-module__XLdpBW__animate-shine",
  "shine": "animations-module__XLdpBW__shine",
  "shine-overlay": "animations-module__XLdpBW__shine-overlay",
});
